<template>
  <div>
    <button
      class="el-tooltip el-tiptap-editor__command-button"
      :class="{ 'is-active': isActive }"
      @click="onClick"
    >
      <svg
        aria-hidden="true"
        width="16"
        height="16"
        viewBox="0 0 512 512"
        focusable="false"
        class="fa-icon"
      >
        <g>
          <path
            d="M464 448h-416c-26.5 0-48-21.5-48-48v-288c0-26.5 21.5-48 48-48h416c26.5 0 48 21.5 48 48v288c0 26.5-21.5 48-48 48zM112 120c-30.9 0-56 25.1-56 56s25.1 56 56 56 56-25.1 56-56-25.1-56-56-56zM64 384h384v-112l-87.5-87.5c-4.7-4.7-12.3-4.7-17 0l-135.5 135.5-55.5-55.5c-4.7-4.7-12.3-4.7-17 0l-71.5 71.5v48z"
          ></path>
        </g>
      </svg>
    </button>
    <v-dialog
      persistent
      v-if="addImageDialog"
      v-model="addImageDialog"
      width="500"
    >
      <v-card>
        <v-card-title class="headline grey lighten-2">Add Image</v-card-title>
        <v-card-text>
          <file-upload
            :media="'image'"
            :accept="accepted"
            label="upload"
            :src="docLink"
            :refName="'upload7098'"
            :role="'patient'"
            :multiple="false"
            :module="'referred'"
            :drop="true"
            @uploaded="fileUploaded"
            :uploadFileToServer="true"
            :uploadedImg="uploadedImg"
            @removeImage="deleteImg"
            :isBlogImage="true"
          ></file-upload>
          <span
            v-if="uploadedImgFullUrl.length === 0 && alert == true"
            class="text-danger required-fields"
          >
            {{ requiredAlert }}
          </span>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="closeModal()">Close</v-btn>
          <v-btn color="success" @click="addImg()">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
  
<script>
import FileUpload from "@/components/FileUpload.vue";
export default {
  components: {
    FileUpload,
  },
  data() {
    return {
      addImageDialog: false,
      uploadedImg: [],
      uploadedImgFullUrl: [],
      accepted: "image/png,image/jpg,image/jpeg,application/pdf",
      docLink: null,
      requiredAlert: "This field is required.",
      alert: false,
    };
  },
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick() {
      //   this.$emit("click");
      this.addImageDialog = true;
    },
    fileUploaded(files, uploaded, name) {
      if (uploaded) {
        this.uploadedImgFullUrl = files;
        this.uploadedImg = files.map((el) => {
          return el.split("/").pop();
        });
      }
    },
    deleteImg() {
      this.uploadedImg = [];
      this.uploadedImgFullUrl = [];
    },
    closeModal() {
      this.uploadedImg = [];
      this.uploadedImgFullUrl = [];
      this.addImageDialog = false;
    },
    addImg() {
      if (this.uploadedImgFullUrl.length > 0) {
        if (this.uploadType == "url") {
          this.$emit("uploadedFile", this.uploadedImgFullUrl[0]);
          this.addImageDialog = false;
          this.deleteImg();
        } else {
          this.$emit("click", {
            src: this.uploadedImgFullUrl[0],
            alt: this.uploadedImgFullUrl[0],
          });
          this.closeModal();
        }
      } else {
        this.alert = true;
      }
    },
  },
};
</script>
  
  <style>
/* Add your custom button styling here */
</style>
  